import produce from 'immer';
import { WorkQueueTabConstant } from 'constants/app.constants';
import { SET_AGREEMENTS_DETAILS } from 'containers/Agreements/constants';
import { SET_STATUS_HISTORY } from 'containers/StatusHistory/constants';
// import { SET_INVOLVED_PARTIES } from 'containers/InvolvedParties/constants';
import {
  SET_SEARCH_DETAILS,
  SET_SELECTED_CUST,
  SET_CLEAR_CUSTOMER,
  SET_ACTIVE_TAB,
  SET_MASTER_DATA,
  SET_INVALID_EXPORT,
  SET_EXPORT_ERROR,
  RESET_EXPORT_ERROR,
} from './constants';

export const initialState = {
  customerInfo: { data: [] },
  selectedCustomer: { item: {}, row: 0 },
  activeTab: WorkQueueTabConstant.INVOLVED_PARTIES,
  masterData: {
    commentTypes: [],
    status: false,
  },
  isInvalidExport: false,
  exportError: '',
};

const reducer = (state = initialState, { type, payload }: any) =>
  produce(state, (draft: any) => {
    switch (type) {
      case SET_SEARCH_DETAILS:
        draft.customerInfo = payload;
        if (payload.data.length === 1 && draft.selectedCustomer.item?.associatedLoans) {
          const index: any = payload.data[0].associatedLoans.findIndex(
            (obj: any) =>
              obj.loanNumber === draft.selectedCustomer.item.associatedLoans[draft.selectedCustomer.row].loanNumber
          );
          draft.selectedCustomer = { item: payload.data[0], row: index > -1 ? index : 0 };
        }
        break;
      case SET_SELECTED_CUST:
        draft.selectedCustomer = payload;
        break;
      case SET_CLEAR_CUSTOMER:
        draft.selectedCustomer = initialState.selectedCustomer;
        break;
      case SET_ACTIVE_TAB:
        draft.activeTab = payload;
        break;
      case SET_MASTER_DATA:
        draft.masterData.commentTypes = payload.commentTypes ?? [];
        draft.masterData.status = true;
        break;
      case SET_INVALID_EXPORT:
        draft.isInvalidExport = payload;
        break;
      case SET_EXPORT_ERROR:
        draft.exportError = payload;
        break;
      case RESET_EXPORT_ERROR:
        draft.exportError = '';
        break;
      case SET_AGREEMENTS_DETAILS:
        {
          const { row } = draft.selectedCustomer;
          if (row >= 0 && draft.selectedCustomer.item.associatedLoans) {
            const {
              data: [itm],
            } = payload;
            if (itm) {
              const associatedLoan = draft.selectedCustomer.item.associatedLoans[row];
              associatedLoan.regLimitRequest = itm.regLimitRequest;
              associatedLoan.regLimitApproved = itm.regLimitApproved;
              associatedLoan.specialLimitRequest = itm.specialLimitRequest;
              associatedLoan.specialLimitApproved = itm.specialLimitApproved;
              draft.selectedCustomer.item.associatedLoans[row] = associatedLoan;
            }
          }
        }
        break;
      case SET_STATUS_HISTORY:
        {
          const { row } = draft.selectedCustomer;
          if (row >= 0 && draft.selectedCustomer.item.associatedLoans) {
            const associatedLoan = draft.selectedCustomer.item.associatedLoans[row];
            associatedLoan.status = payload.data.history && payload.data.history[0]?.statusDesc;
            draft.selectedCustomer.item.associatedLoans[row] = associatedLoan;
          }
        }
        break;
      // case SET_INVOLVED_PARTIES: {
      //   const { row } = draft.selectedCustomer;
      //   if (row >= 0 && draft.selectedCustomer.item.associatedLoans) {
      //     const { data } = payload;
      //     const idx = data.findIndex((itm:any) => Number(itm.typeId) === 1);
      //     if (idx > -1) {
      //       const associatedLoan = draft.selectedCustomer.item.associatedLoans[row];
      //       associatedLoan.status = payload.data.history && payload.data.history[0]?.statusDesc;
      //       draft.selectedCustomer.item.associatedLoans[row] = associatedLoan;
      //     }
      //   }
      // }
      // break;
      default: {
        break;
      }
    }
  });

export default reducer;
